import React from 'react';
import { Phone } from 'lucide-react';
import { useBrand } from './BrandProvider';

/**
 * Floating Phone Button Component
 * A fixed button at the bottom right corner for easy phone access
 */
const FloatingPhoneButton = () => {
  const brand = useBrand();

  return (
    <a
      href={`tel:${brand.contact.phone}`}
      className="fixed bottom-6 right-6 z-50 bg-celadon hover:bg-celadon/90 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all hover:scale-110 group"
      title={`Appelez-nous : ${brand.contact.phoneDisplay}`}
      aria-label="Appeler"
    >
      {/* Phone Icon with animation */}
      <Phone size={28} className="group-hover:animate-bounce" />
      
      {/* Tooltip on hover - desktop only */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity hidden md:block">
        {brand.contact.phoneDisplay}
      </span>
      
      {/* Pulse ring effect */}
      <span className="absolute inset-0 rounded-full bg-celadon animate-ping opacity-25"></span>
    </a>
  );
};

export default FloatingPhoneButton;
